export class MultipleLookupConfig {
  constructor(data) {
    this.title = data.title;

    this.clearable = data.clearable ?? false;

    /** @type {Function} */
    this.fetch = data.fetch;

    /** @type {Function} */
    this.toReadable = data.toReadable;
  }
}
